import RewardsWalletBase from './RewardsWalletBase';

export default RewardsWalletBase;
